import { withRouter } from "react-router-dom";
import compose from "recompose/compose";
import { connect } from "react-redux";
import withHandlers from "recompose/withHandlers";
import { withFormik } from "formik";
import DiscountForm from "./DiscountForm";
import {
  addPromoCodeThenUpdatePayments,
  addPromoCode,
} from "src/client/js/store/thunks/cart";
import { getCartErrors } from "src/client/js/store/selectors/cart";
import withCountry from "../../../hocs/withCountry";
import withGlobalContent from "../../../hocs/withGlobalContent";
import withErrorTranslations from "../../../hocs/withErrorTranslations";
import { getCookies } from "../../../../facades/eagle/helpers/cookies";
import { trackGeneralClick } from "../../../../analytics/category/checkout";

const enhance = compose(
  withGlobalContent,
  withRouter,
  withErrorTranslations,
  withCountry,
  connect(
    (state) => ({
      cartErrors: getCartErrors(state),
    }),
    (dispatch) => ({
      addPromoCode: (code, resetForm, props) => {
        props.location.pathname.includes("/checkout-v2/payment")
          ? dispatch(
              addPromoCodeThenUpdatePayments(
                code,
                resetForm,
                getCookies(),
                props.countryModel,
                props.errorMessage
              )
            )
          : dispatch(addPromoCode(code, resetForm));
      },
    })
  ),
  withCountry,
  withFormik({
    mapPropsToValues: () => ({ code: "" }),
    handleSubmit: (values, { props, ...action }) => {
      trackGeneralClick("Apply discount", props.history.location.pathname);
      props.addPromoCode(values.code, action.resetForm, props);
    },
  }),
  withHandlers({
    handleClick: (props) => () => {
      trackGeneralClick(
        "into promo code field",
        props.history.location.pathname
      );
    },
  })
);

export default enhance(DiscountForm);
